import { createAction, props } from '@ngrx/store'
import { UserModel, UserRolesModel, SentInvitationModel, UserBusinessModel, RequestModel, ResponseModel } from '@models/index'

export const searchUsersByBusiness = createAction(
    '[Users Page] Search Users By Business',
    props<{ request: RequestModel }>()
)

export const searchUsersByQueryByBusiness = createAction(
    '[Users Page] Search Users By Query By Business',
    props<{ request: RequestModel }>()
)

export const searchUsersByBusinessSuccess = createAction(
    '[Users Page] Search Users By Business Success',
    props<{ users : UserBusinessModel[] }>()
)

export const searchUserRoles = createAction(
    '[Users Page] Search User Roles'
)

export const searchUserRolesSuccess = createAction(
    '[Users Page] Search User Roles Success',
    props<{ userRoles : UserRolesModel[] }>()
)

export const createUserSuccess = createAction(
    '[Users Page] Create Users Success',
    props<{ user : UserModel }>()
)

export const searchUsersByQuery = createAction(
    '[Users Page] Search Users By Query',
    props<{ request: RequestModel }>()
)

export const searchUsersByQuerySuccess = createAction(
    '[Users Page] Search Users By QuerySuccess',
    props<{ foundUsers : UserModel[] }>()
)

export const addRoleToUserToBusiness = createAction(
    '[Users Page] Add Role To User To Business',
    props<{ payload: { user : UserModel, role: UserRolesModel, businessId: string }}>()
)

export const addRoleToUserToBusinessSuccess = createAction(
    '[Users Page] Add Role To User To Business Succes',
    props<{ user : UserBusinessModel }>()
)

export const addRoleToUserToReseller = createAction(
    '[Users Page] Add Role To User To Reseller',
    props<{ request: RequestModel}>()
)

export const addRoleToUserToResellerSuccess = createAction(
    '[Users Page] Add Role To User To Reseller Succes',
    props<{ user : UserBusinessModel }>()
)

export const searchSentInvitations = createAction(
    '[Users Page] Search Sent Invitations',
    props<{ businessId : string }>()
)

export const searchSentInvitationsSuccess = createAction(
    '[Users Page] Search Sent Invitations Success',
    props<{ sentInvitations: SentInvitationModel[] }>()
)

export const searchSentInvitationStatesSuccess = createAction(
    '[Users Page] Search Sent Invitation States Success',
    props<{ sentInvitationStates: string[] }>()
)

export const createSentInvitation = createAction(
    '[Users Page] Create Sent Invitation',
    props<{ sentInvitation : SentInvitationModel }>()
)

export const createSentInvitationSuccess = createAction(
    '[Users Page] Create Sent Invitation Success',
    props<{ sentInvitation : UserBusinessModel }>()
)

export const createSentInvitationToReseller = createAction(
    '[Users Page] Create Sent Invitation To Reseller',
    props<{ request : RequestModel }>()
)

export const deleteUser = createAction(
    '[Users Page] Delete Sent Invitation',
    props<{ userId : string }>()
)

export const deleteUserSucces = createAction(
    '[Users Page] Delete Sent Invitation Success',
    props<{ userId : string }>()
)

export const deleteUserFromReseller = createAction(
    '[Users Page] Delete User From Reseller',
    props<{ request: RequestModel }>()
)

export const deleteUserFromResellerSuccess = createAction(
    '[Users Page] Delete User From Reseller Success',
    props<{ userId : string }>()
)

export const resendSentInvitation = createAction(
    '[Users Page] Resend Sent Invitation',
    props<{ payload: {userId : string, resellerId: string, businessId: string} }>()
)

export const resendSentInvitationSuccess = createAction(
    '[Users Page] Resend Sent Invitation Success',
    props<{ sentInvitation : boolean }>()
)

export const searchAllUsers = createAction(
    '[Users Page] Search All Users',
    props<{ request: RequestModel }>()
)

export const searchAllUsersSuccess = createAction(
    '[Users Page] Search All Users Success',
    props<{ users : ResponseModel }>()
)

export const searchUsersByReseller = createAction(
    '[Users Page] Search Users By Reseller',
    props<{ request: RequestModel }>()
)

export const searchUsersByResellerSuccess = createAction(
    '[Users Page] Search Users By Reseller Success',
    props<{ users : UserBusinessModel[] }>()
)

export const clearUsersList = createAction(
    '[Users Page] Cleat Users List'
)

export const setResentInvitation = createAction(
    '[Users Page] Set Resent Invitation',
    props<{ value : boolean }>()
)

export const usersError = createAction(
    '[Users Page] Users Error',
    props<{ error : string }>()
)

export const editUser = createAction(
    '[Users Page] Edit Users',
    props<{ request : RequestModel }>()
)

export const editUserSuccess = createAction(
    '[Users Page] Edit Users Success',
    props<{ user : UserModel }>()
)

export const saveUserPhoneNumber = createAction(
    '[Users Page] Save Users Phone Number',
    props<{ request : RequestModel }>()
)
export const saveUserPhoneNumberSuccess = createAction(
    '[Users Page] Save Users Phone Number Success',
    props<{ user : UserModel }>()
)

export const updateShowModalPhoneNumber = createAction(
    '[Users Page] Update Show Modal PhoneNumber',
    props<{ request : RequestModel }>()
)

export const updateShowModalPhoneNumberSuccess = createAction(
    '[Users Page] Update Show Modal PhoneNumber Success',
    props<{ user : UserModel }>()
)
export const updateRoleOnResellerView = createAction(
    '[Users Page] Update Role On Reseller View',
    props<{ request : RequestModel }>()
)
export const updateRoleOnBusinessView = createAction(
    '[Users Page] Update Role On Business View',
    props<{ request : RequestModel }>()
)
export const updateRoleSuccess = createAction(
    '[Users Page] Update Role Success',
    props<{  user : UserModel  }>()
)
